import { CaseDocumentAdmin } from "custom-models";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const autoAttachDocuments = [
  "DIF-Report",
  "Fish-Report",
  "Molecular-Report",
  "Consultation-Report",
  "Lab-Report",
];

export const canAttachDocument = (category: string) => {
  return autoAttachDocuments.includes(category) || category === "Other";
};

export const submissionFieldsForDocument = (
  _document: CaseDocumentAdmin,
  values?: Partial<CaseDocumentAdmin>,
  useMergeCaseReportWorkflow?: boolean
) => {
  if (!values) values = _document;

  const attach_to_case_report = getAttachToCaseReportforApi(
    values.attach_to_case_report,
    useMergeCaseReportWorkflow,
    values.category
  );

  return {
    case_id: values.case ? values.case.id : _document.case_id,
    case__accession: values.case
      ? values.case.accession
      : _document.case__accession,
    category: values.category || null,
    status: values.status || null,
    name: values.name || null,
    ...(attach_to_case_report === null
      ? {}
      : { attach_to_case_report: attach_to_case_report }),
  };
};

export const shallowDocumentComparison = (
  _document: CaseDocumentAdmin,
  values: Partial<CaseDocumentAdmin>,
  useMergeCaseReportWorkflow?: boolean
) => {
  const oldValues = submissionFieldsForDocument(
    _document,
    undefined,
    useMergeCaseReportWorkflow
  );
  const newValues = submissionFieldsForDocument(
    _document,
    values,
    useMergeCaseReportWorkflow
  );

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForDocument>>(
    oldValues,
    newValues
  );
};

export const getAttachToCaseReportforApi = (
  attachToDocument?: boolean | null,
  useMergeCaseReportWorkflow?: boolean,
  category?: CaseDocumentAdmin["category"]
): string | null => {
  const test =
    useMergeCaseReportWorkflow &&
    attachToDocument !== undefined &&
    attachToDocument !== null &&
    canAttachDocument(category ?? "")
      ? attachToDocument
        ? "true"
        : "false"
      : null;

  return test;
};
